import Axios from "axios";
import Product from "../interfaces/product";
export class ProductService {
    public static async getProduct(route: string): Promise<Product> {
        const uri = `/api/product/${route}`;
        const response = await Axios.get(uri);

        return response.data;
    }
}
